import React, { useState, useEffect, useContext } from "react";

import Table from "../../common/Table";

import { Link } from "react-router-dom";

import db from "../../../services/query";
import { HalfYearContext } from "../../../contexts/halfYearContext";

const DebtPayments = ({halfYearId}) => {
  const { halfYear } = useContext(HalfYearContext);

  const columns = [
    { path: "id", label: "شماره" },
    {
      path: "name",
      label: "بخش",
      content: (e) => (
        <Link to={`/mis/expenses/debtType/${e.id}/creditors`}>{e.name}</Link>
      ),
    },
    {
      path: "creditor_count",
      label: "تعداد بدهکار",
    },
    {
      path: "payable",
      label: "قابل پرداخت",
    },
    {
      path: "paid",
      label: "پرداخت شده",
    },
    {
      path: "balance",
      label: "باقیمانده",
    },
    {
      path: "overall_balance",
      label: "باقی‌مانده کل ",
    },
    { path: "option" },
  ];

  const [data, setData] = useState([]);

  useEffect(() => {
    const ac = new AbortController();

    requestData({ halfYear });

    return () => ac.abort();
  }, [halfYear]);

  const requestData = async (p = new Object()) => {
    try {
      const { halfYear } = p;

      let query = `expenses/debtTypes?halfYearId=${halfYearId || halfYear}`;

      await db.getAll(query).then(({ data }) => {
        setData(data);
      });
    } catch ({ response }) {
      setData(response);
    }
  };

  return <Table data={data} columns={columns} />;
};

export default DebtPayments;
